<template>
  <div class="">
    <!-- //页面数组循环 -->
    <div v-for="(item, index) in templateList" :key="index">
   <!-- 第一个组件 -->
            <Templates1
              v-if="item.templateName == 'templates1'"
              :indata="item"
            ></Templates1>
            <!-- 第二个组件 -->
            <Templates2
              v-if="item.templateName == 'templates2'"
              :indata="item"
            ></Templates2>
            <!-- 第三个组件 -->
            <Templates3
              v-if="item.templateName == 'templates3'"
              :indata="item"
            ></Templates3>
            <!-- 第四个组件 -->
            <Templates4
              v-if="item.templateName == 'templates4'"
              :indata="item"
            ></Templates4>
            <!-- 第五个组件 -->
            <Templates5
              v-if="item.templateName == 'templates5'"
              :indata="item"
            ></Templates5>
            <!-- 第六个组件 -->
            <Templates6
              v-if="item.templateName == 'templates6'"
              :indata="item"
            ></Templates6>
            <!-- 第七个组件 -->
            <Templates7
              v-if="item.templateName == 'templates7'"
              :indata="item"
            ></Templates7>
            <!-- 第八个组件 -->
            <Templates8
              v-if="item.templateName == 'templates8'"
              :indata="item"
            ></Templates8>
            <!-- 第九个组件 -->
            <Templates9
              v-if="item.templateName == 'templates9'"
              :indata="item"
            ></Templates9>
            <!-- 第十个组件 -->
            <Templates10
              v-if="item.templateName == 'templates10'"
              :indata="item"
            ></Templates10>
            <!-- 第十一个组件 -->
            <Templates11
              v-if="item.templateName == 'templates11'"
              :indata="item"
            ></Templates11>
            <!-- 第十二个组件 -->
            <Templates12
              v-if="item.templateName == 'templates12'"
              :indata="item"
            ></Templates12>
            <!-- 第十三个组件 -->
            <Templates13
              v-if="item.templateName == 'templates13'"
              :indata="item"
            ></Templates13>
            <!-- 第十四个组件 -->
            <Templates14
              v-if="item.templateName == 'templates14'"
              :indata="item"
            ></Templates14>
            <!-- 第十五个组件 -->
            <Templates15
              v-if="item.templateName == 'templates15'"
              :indata="item"
            ></Templates15>
            <!-- 第十六个组件 -->
            <Templates16
              v-if="item.templateName == 'templates16'"
              :indata="item"
            ></Templates16>
            <!-- 第十七个组件 -->
            <Templates17
              v-if="item.templateName == 'templates17'"
              :indata="item"
            ></Templates17>
            <!-- 第十八个组件 -->
            <Templates18
              v-if="item.templateName == 'templates18'"
              :indata="item"
            ></Templates18>
            <!-- 第十九个组件 -->
            <Templates19
              v-if="item.templateName == 'templates19'"
              :indata="item"
            ></Templates19>
            <!-- 第二十个组件 -->
            <Templates20
              v-if="item.templateName == 'templates20'"
              :indata="item"
            ></Templates20>
            <!-- 第二十一个组件 -->
            <Templates21
              v-if="item.templateName == 'templates21'"
              :indata="item"
            ></Templates21>
            <!-- 第二十二个组件 -->
            <Templates22
              v-if="item.templateName == 'templates22'"
              :indata="item"
            ></Templates22>
            <!-- 第二十三个组件 -->
            <Templates23
              v-if="item.templateName == 'templates23'"
              :indata="item"
            ></Templates23>
            <!-- 第二十四个组件 -->
            <Templates24
              v-if="item.templateName == 'templates24'"
              :indata="item"
            ></Templates24>
            <!-- 第二十五个组件 -->
            <Templates25
              v-if="item.templateName == 'templates25'"
              :indata="item"
            ></Templates25>
            <!-- 第二十六个组件 -->
            <Templates26
              v-if="item.templateName == 'templates26'"
              :indata="item"
            ></Templates26>
            <!-- 第二十七个组件 -->
            <Templates27
              v-if="item.templateName == 'templates27'"
              :indata="item"
            ></Templates27>
    </div>


  </div>
</template>

<script>
import Templates1 from "@/demo/templates1.vue";
import Templates2 from "@/demo/templates2.vue";
import Templates3 from "@/demo/templates3.vue";
import Templates4 from "@/demo/templates4.vue";
import Templates5 from "@/demo/templates5.vue";
import Templates6 from "@/demo/templates6.vue";
import Templates7 from "@/demo/templates7.vue";
import Templates8 from "@/demo/templates8.vue";
import Templates9 from "@/demo/templates9.vue";
import Templates10 from "@/demo/templates10.vue";
import Templates11 from "@/demo/templates11.vue";
import Templates12 from "@/demo/templates12.vue";
import Templates13 from "@/demo/templates13.vue";
import Templates14 from "@/demo/templates14.vue";
import Templates15 from "@/demo/templates15.vue";
import Templates16 from "@/demo/templates16.vue";
import Templates17 from "@/demo/templates17.vue";
import Templates18 from "@/demo/templates18.vue";
import Templates19 from "@/demo/templates19.vue";
import Templates20 from "@/demo/templates20.vue";
import Templates21 from "@/demo/templates21.vue";
import Templates22 from "@/demo/templates22.vue";
import Templates23 from "@/demo/templates23.vue";
import Templates24 from "@/demo/templates24.vue";
import Templates25 from "@/demo/templates25.vue";
import Templates26 from "@/demo/templates26.vue";
import Templates27 from "@/demo/templates27.vue";

export default {
  name: "ShowTemplates",
  props: {
    templateList: Array,
  },methods: {
  },
  components: {
    Templates1,
    Templates2,
    Templates3,
    Templates4,
    Templates5,
    Templates6,
    Templates7,
    Templates8,
    Templates9,
    Templates10,
    Templates11,
    Templates12,
    Templates13,
    Templates14,
    Templates15,
    Templates16,
    Templates17,
    Templates18,
    Templates19,
    Templates20,
    Templates21,
    Templates22,
    Templates23,
    Templates24,
    Templates25,
    Templates26,
    Templates27,
  },
};
</script>
<style >

.el-dialog__header{
      background-color: #4E6EF2;
      padding: 10px 20px 10px;
}
.el-dialog__title{
  color: white;
}
.el-dialog__body {
padding: 10px 20px;  
  }
  .el-form-item {
    margin-bottom: 15px;
}.el-dialog__headerbtn {

top:13px} 
 .el-dialog__headerbtn .el-dialog__close{
  color:white
}
</style>